import { ROLES } from '../../../types/role/role';
// helper function
export const disabledLink = (disabled, role) => {
    const roleRes = disabled && !role ? ROLES.LINK : role;
    return { role: roleRes };
};
//# sourceMappingURL=disabled.js.map